// Checkbox.js
import React from 'react';

const RadioBox = ({ label, checked, onChange, disabled = false, name, value, className }) => {
  return (
    <label className={className} style={{ display: 'flex', height: '45px', alignItems: 'center', gap: '8px', cursor: disabled ? 'not-allowed' : 'pointer' }}>
      <input
        type="radio"
        checked={checked}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={{ width: '20px', height: '16px' }}
      />
      <span style={{ marginLeft: '8px' }}>{label}</span>
    </label>
  );
};

export default RadioBox;
